import { useMemo, useState } from "react";
import CustomModal from "../Modals/CustomModal";
import LimitsStateView from "./LimitsStateView";
import LimitDetails, { LimitDetailProps } from "./LimitDetails";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import AlertCategory from "src/consts/AlertCategory";
import React from "react";
import { Row } from "antd";
import CustomButton from "../CustomButton";
import { CloseOutlined } from "@ant-design/icons";
import EventCategory from "src/consts/EventCategory";

interface LimitsModalProps{
    binDto: PremierPlusBinDTO | null | undefined;
    showLimitsModal: boolean;
    onClose: () => void;
    parentRef?: React.RefObject<HTMLElement>;
}

const LimitsModal : React.FC<LimitsModalProps> = ({ parentRef, binDto, showLimitsModal, onClose }) => {

    const [limitDetail, setLimitDetail] = useState<LimitDetailProps | null>(null);

    const limitStates = useMemo( () => {
        return binDto?.activeAlerts?.filter( (a) => a.eventCategory === EventCategory.Limit)?? [];
    },[binDto]);

    const handleClickLimit = (limit: LimitDetailProps | null | undefined) => {

        if(limit == null || limit.tripped != true) return;
        setLimitDetail(limit);

    }

    const handleClose = () => {
        if(limitDetail != null){
            setLimitDetail(null);
        }else{
            onClose();
        }
    }

    return(
        <CustomModal 
        show={showLimitsModal}
        onClose={handleClose}
        title={'System Limit Switches'}
        parentRef={parentRef}
        >
            {
                limitDetail == null ? 
                <LimitsStateView
                limitStates={limitStates}
                onClickLimit={handleClickLimit}
                />
                :
                <LimitDetails 
                title={limitDetail.title}
                description={limitDetail.description}
                perps={limitDetail.perps}
                tripped={limitDetail.tripped}
                />
            }
            <Row justify={'end'}>
                <CustomButton variant='secondary' label={'Close'} icon={<CloseOutlined/>} onClick={handleClose}/>
            </Row>             
        </CustomModal>
    )
}
export default LimitsModal;